import { render, staticRenderFns } from "./marqueeWrap.vue?vue&type=template&id=c6e46fe6&scoped=true"
import script from "./marqueeWrap.vue?vue&type=script&lang=js"
export * from "./marqueeWrap.vue?vue&type=script&lang=js"
import style0 from "./marqueeWrap.vue?vue&type=style&index=0&id=c6e46fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e46fe6",
  null
  
)

export default component.exports